/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
	/* To load js in all pages */
	if(Flits?.Metafields?.IS_SOCIAL_LOGIN_PAID && Flits?.Metafields?.IS_SOCIAL_LOGIN_ENABLE && Flits?.customer_id == -1) {
		if(window?.flitsObjects?.allCssJs?.socialLoginJs) {
			Flits.LoadStyleScript('socialLoginJs', window?.flitsObjects?.allCssJs?.socialLoginJs?.url);
		}
	}
	var ajaxWishlistViewFunction = function(xhrOrFetch) {
		var url = this._url;
		// You can add your choice of URL Instead '?view=quick-view'
		(-1 !== url.indexOf("?sv=") || url.indexOf("?section_id=")) && Flits.dispatchEvent("Flits:AjaxWishlist", {
			response: this,
			xhrOrFetch: xhrOrFetch
		})
	};
	Flits.addAjaxEvents(ajaxWishlistViewFunction);
	Flits.addFetchEvents(ajaxWishlistViewFunction);
	Flits(document).on("Flits:AjaxWishlist", function() {
		setTimeout(function() {
			var grid = Flits(".collection-grid__wrapper").find(".flits-wishlist-colection .flits-wls-button");
			Flits(grid).each(function(index, single_grid_item) {
				var handle = Flits(single_grid_item).attr('data-flits-product-handle');
				Flits(single_grid_item).parent().css('display', 'flex');
				Flits(single_grid_item).find('.flits-wls-icon-with-text-text').css('display', 'flex');
				if(Flits.isProductAddedInWishlist(handle)) {
					Flits(single_grid_item).removeClass("flits-wls-inactive");
					Flits(single_grid_item).addClass("flits-wls-active");
					Flits(single_grid_item).find(".flits-wls-icon-with-text-text").html(Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
				}
			});
		}, 2000);
	});
  
	Flits(document).on("click", ".flits-add-to-cart", function(event) {
		event.preventDefault();
		event.stopPropagation();
		event.stopImmediatePropagation();
        let dataFormAction = Flits(this).attr('data-flits-add-action-from');
		let el = Flits(this);
		let quantity = parseInt(Flits(el).parents(".flits-product-card").find('input[name="product_quantity_input"]').val());
		let maxLimit = parseInt(Flits(el).parents(".flits-product-card").find('input[name="product_quantity_input"]').attr("max"));
		let id = Flits(el).parents(".flits-product-card").find(".flits-variant-select").val();
		let interval = 0;
		cartOrder[id] && quantity + parseInt(cartOrder[id].cart_quantity) > maxLimit && ((quantity = maxLimit - parseInt(cartOrder[id].cart_quantity)), quantity == 0 ? (quantity = maxLimit) : quantity, (interval = 3000), flitsSnackbar.show({
			text: Flits.t("Flits.locals.general.cart_updated", "Some items are no longer available. Your cart has been updated."),
			pos: "bottom-center",
			showAction: !1,
			customClass: "flits-alert-default"
		}));
		let data = "id=" + id + "&quantity=" + quantity + "&productstatus=" + dataFormAction;
      	setTimeout(function() {
			addToCartN(data, dataFormAction, el);
		}, interval);
		return false;
	});
  var product_key = null;
    function addToCartN(params, dataFormAction, el) {
		flitsSnackbar.show({
				text: Flits.t("Flits.locals.cart_page.adding_items_to_cart", "Adding items to cart..."),
				pos: "bottom-center",
				showAction: !1,
				customClass: "flits-alert-default",
				duration: !1
			}),
			Flits.ajax({
				type: "POST",
				url: "/cart/add.js",
				data: params,
				dataType: "json"
			}).done(function(resp) {
               product_key = resp.key;
				Flits.flitsSnackbarHide(); //(location.href = "/cart");
				Flits.ajax({
					type: 'get',
					url: '/cart.js',
					dataType: 'json',
                    async: false,
					success: function(cart) {
                      // console.log(el);
                      // for(var i = 1; i < 8; i++){
                      //   console.log(i);
                      // }
						Flits('span.cart-link__bubble').html(cart.item_count);
						Flits('span.cart-link__bubble').addClass('cart-link__bubble--visible');
                        flitsSnackbar.show({
							text: Flits.t("Flits.locals.cart_page.items_added_to_cart", "Item Added to cart"),
							pos: "bottom-center",
							showAction: !1,
							customClass: "flits-alert-success flits-rv-snackbar",
							duration: 1501
						});
						document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                          detail: {
								product: cart,
								addToCartBtn: this.addToCart
							}
						}));

                    }
				});
                if(dataFormAction == 'wishlist'){
                  Flits(el).siblings('.flits-remove-product').trigger('click');
                  if(Flits('.js-drawer-open-cart').length){
                    Flits('.js-drawer-open-cart')[0].click();
                  }
                }
                
			}).fail(function(resp) {
				flitsSnackbar.show({
					text: resp.responseJSON.description,
					pos: "bottom-center",
					showAction: !1,
					customClass: "flits-alert-error"
				});
			}).always(function() {});
	}
  
  // Flits(document).on('Flits:Navigation:Loaded', function(event){
  // var settings = event.detail.settings;
  // var obj = {
  //   title: 'Webkul Wallet',
  //   url:'#WebkulWallet',
  //   target:0,
  //   badge: null,
  //   icon: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"><path d="M9.92,19.5a.4.4,0,0,1-.28-.12A.4.4,0,0,1,9.53,19l.56-2.8a.39.39,0,0,1,.11-.2l6.16-6.16a1.19,1.19,0,0,1,1.68,0L19.15,11a1.19,1.19,0,0,1,0,1.68L13,18.82a.39.39,0,0,1-.2.11l-2.8.56H9.92m.92-3-.42,2.1,2.1-.42,6.07-6.07a.4.4,0,0,0,0-.56l-1.12-1.12a.4.4,0,0,0-.56,0ZM12,2.87H10.79v-.4a.4.4,0,0,0-.4-.4H9.17a2,2,0,0,0-3.88,0H4.06a.4.4,0,0,0-.4.4v.4H2.48a2,2,0,0,0-2,2V15.15a2,2,0,0,0,2,2H8a.4.4,0,0,0,0-.79H2.48a1.19,1.19,0,0,1-1.19-1.19V4.85A1.19,1.19,0,0,1,2.48,3.67H3.67v.4A1.19,1.19,0,0,0,4.85,5.25H9.6a1.19,1.19,0,0,0,1.19-1.19v-.4H12a1.19,1.19,0,0,1,1.19,1.19V9.6a.4.4,0,1,0,.79,0V4.85a2,2,0,0,0-2-2M10,4.06a.4.4,0,0,1-.4.4H4.85a.4.4,0,0,1-.4-.4V2.87H5.65a.4.4,0,0,0,.4-.4,1.19,1.19,0,0,1,2.38,0,.4.4,0,0,0,.4.4H10Zm1.19,3.56H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79" transform="translate(-0.5 -0.5)" /></svg>',
  //   isShow: 1,
  //   loader:null,
  //   body_html:'<div id="custom-webkul-wallet"></div>'
  // }
  // settings.navs.splice(5, 0, obj);
  // });
  // function flitswebkulCustomIntregation(){
  //   var wk_wallet_integrated_page = Flits(".flits-custom-wallet-page").html();
  //   Flits("#flits_tab_WebkulWallet").find("#custom-webkul-wallet").html(wk_wallet_integrated_page);
  //   Flits("#flits_mobile_tab_WebkulWallet").find("#custom-webkul-wallet").html(wk_wallet_integrated_page);
  //   Flits(".flits-custom-wallet-page").remove();
  // }
  // Flits(document).on('Flits:AccountPage:Loaded', function(event){  
  //   flitswebkulCustomIntregation();    
  // });
  
  Flits(document).on('Flits:SocialLogin:Loaded', function(event){  
    setTimeout(function(){
      if (location.pathname.indexOf("/account") == -1){  
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }, 800);
  });

  Flits(window).load(function() {  
    if (location.pathname.indexOf("/account") == -1){     
      if (location.pathname.indexOf("checkout") != -1)
      {
        Flits.setLocalStorage('flits_before_login_url',location.pathname);
      }else{
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }
  });

  // Flits(document).ready(function(){
  // Flits('.flits-custom-header-wl').click(function(event){
  //  event.preventDefault(); 
     
  // });  
  // });

  Flits(document).on("click", ".flits-move-to-wishlist", function(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
  var loader = `<div class="flits-loading-div flits-social-login-loader flits-move-to-wishlist-loader"> <div class="flits-spinner"></div> </div>`;
    Flits.ajax({
      type: 'get',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        let cartLength = Number(cart.item_count);
        if(cartLength >= 1){
          Flits('body').append(loader);
          Flits(cart.items).each(function(index, ele){
            cartLength--;
            let params = {
              customer_hash: Flits.customerHash,
              token: Flits.token,
              customer_id: Flits.customer_id,
              customer_email: Flits.customer_email,
              product_id: ele.product_id,
              product_handle: ele.handle,
              product_title: ele.title,
              product_image: ele.image
            };
            let add_url = Flits.base_url + '/wishlist/add_to_wishlist';
            Flits.ajax({
                type: 'POST',
                url: add_url,
                data: params,
                contentType: 'application/x-www-form-urlencoded'
            }).done(function(resp) {
              if(cartLength === 0){
                window.location.href = '/account#wishlist';
                if(window.location.pathname == '/account'){
                  window.location.reload();
                }
                Flits('.flits-move-to-wishlist-loader').remove();
              }
            })
          });
        }
        else{
          flitsSnackbar.show({ text: 'Please add item in a cart first', pos: "bottom-center", showAction: !1, customClass: "flits-alert-success flits-rv-snackbar", duration: 3501 });
        }
      }
    });
    setTimeout(function(){
      Flits.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function() { 
        
      },
      error: function(XMLHttpRequest, textStatus) {
        /* error code */
      }
    });
    }, 2000);
  });

  Flits(document).on('click', "#flits-wishlist-product-list .flits-wsl-filter-btn", function(){
    Flits('#flits-wishlist-product-list .flits-wsl-filter-btn').removeClass('active');
    Flits(this).addClass('active');
    var thisButtonType = Flits(this).attr("data-type");
    var listObj = Flits.Wishlist.settings.wishlistList;
    listObj.search(thisButtonType);
  });
  Flits(document).on('click', "#flits-wishlist-product-mobile-list .flits-wsl-filter-btn", function(){
    Flits('#flits-wishlist-product-mobile-list .flits-wsl-filter-btn').removeClass('active');
    Flits(this).addClass('active');
    var thisButtonType = Flits(this).attr("data-type");
    var listObj = Flits.Wishlist.settings.wishlistMobileList;
    listObj.search(thisButtonType);
  });
  Flits(document).on('Flits:AddressDefault:Click', function(event){
    var form = event.detail.item;
    var countryVal = form.find(".flits-address-phone-with-country-div .flits-country-code-textbox").val();
    if(!countryVal){
      Flits('.flits-address-card-action').removeClass('flits-disabled');
      flitsSnackbar.show({ text: "Please add your phone country code", pos: "bottom-center", showAction: !1, customClass: "flits-alert-danger", duration: 2400 });
    }
  });
  Flits(document).on('Flits:AddressSave:Click', function(event){
    var form = event.detail.item;
    var countryVal = form.find(".flits-address-phone-with-country-div .flits-country-code-textbox").val();
    if(!countryVal){
      flitsSnackbar.show({ text: "Please add your phone country code", pos: "bottom-center", showAction: !1, customClass: "flits-alert-danger", duration: 2400 });
    }
  });


  // STORE CREDIT DISABLE

  // Flits(document).on('Flits:Navigation:Loaded', function(event){
  //   let navigation = event.detail.settings.navs;
  //   for(i=0;i<navigation.length;i++){
  //     if(navigation[i].url=="#storeCredit"){
  //       navigation[i].isShow=0;
  //     }
  //     if(navigation[i].url=="#howToEarn"){
  //       navigation[i].isShow=0;
  //     }
  //     if(navigation[i].url=="#howToSpend"){
  //       navigation[i].isShow=0;
  //     }
  //     if(navigation[i].url=="#referFriend"){
  //       navigation[i].isShow=0;
  //     }
  //     if(i==14 || i==16){
  //       navigation[i].isShow=0;
  //     }
  //   }
  // });

  // Flits(document).on("Flits:StoreCreditCart:Loaded", function(event){
  //   event.detail.settings.isCodeAutomatic = 0;
  //   setTimeout(function(){
  //     Flits(".flits-credit-code-div").remove();
  //   },1500);
  // });

   /* Kwikpass added the below event */
  Flits(document).on("Flits:AccountPage:Loaded", function (event) {
    Flits(".logoutcustom").on("click", function () {
      event.preventDefault();
      //handleLogout();
      window.location.href = '/account/logout';
    });
  });
  
}(Flits));